import { validator } from "@/utils/validator";

export const recoverSchema = validator.object().shape({
  companyCode: validator.string().trim().emptyToNull().autoTransformToHalfWidth().label("企業ID").required(),
  email: validator.string().trim().emptyToNull().autoTransformToHalfWidth().label("メールアドレス").required(),
});
